import validations from "@/locales/ko/validations/common.json";

export default {
    validations,
};
